import React, { useEffect, useState } from 'react';
import style from '../admin/exam/ExamResult.module.css'
import EditIcon from '@mui/icons-material/Edit';
import { Link } from 'react-router-dom';
import moment from 'moment';

const Profile = ({ userData }) => {
  const [profile, setProfile] = useState({
    name: userData.name,
    email: userData.email,
    contact:userData.contact,
    class: userData.className,
    subscribedCourses: userData.enrolledCourses,
    studentId: userData.studentID,
    dob: userData.dob,
    gender: userData.gender,
    fatherName: userData.fatherName,
    motherName: userData.motherName,
    category: userData.category,
    password: userData.password,
    newPassword: ""
  });
  useEffect(() => {
    setProfile({
      name: userData.name,
      email: userData.email,
      contact:userData.contact,
      class: userData.className,
      subscribedCourses: userData.enrolledCourses,
      studentId: userData.studentID,
      dob: userData.dob,
      gender: userData.gender,
      fatherName: userData.fatherName,
      motherName: userData.motherName,
      category: userData.category,
      password: userData.password,
      newPassword: ""
    })
  }, [userData])

  return (
    <div className='profile-container mb-3'>
      <div className={`profile-content container-fluid mt-3 ${style.instruction}`}>
      <div style={{justifySelf:'center'}}><img width='280px' src='/assets/images/monoarclogo.jpeg' alt='logo'/></div>
        <h4 className='text-center mb-3 pb-2' style={{borderBottom:'1px solid black'}}>Student Profile</h4>
        <div className="row mb-4">
          <div className='col-md-6 col-sm-12'>
            <p><strong>Name:</strong> {profile.name}</p>
          </div>
          <div className='col-md-6 col-sm-12'>
            <p><strong>Email:</strong> {profile.email}</p>
          </div>
        </div>
        <div className="row mb-4">
        <div className='col-md-6 col-sm-12'>
            <p><strong>Class:</strong> {profile.class}</p>
          </div>
          <div className='col-md-6 col-sm-12'>
            <p><strong>Student ID:</strong> {profile.studentId}</p>
          </div>
        </div>
        <div className="row mb-4">
        <div className='col-md-6 col-sm-12'>
            <p><strong>Contact:</strong> {profile.contact}</p>
          </div>
        </div>
        <div className='row mb-4'>
          <div className='col-6'>
            <p><strong>Subscribed Courses:</strong> {
              profile?.subscribedCourses?.length>0&&
              profile.subscribedCourses.map((course,i)=>
              <span className='d-flex flex-direction-column'>{i+1}. {course.title} {course.className&&`(${course.className})`}</span>)
            }</p>
          </div>
          <div className='col-6'>
          <p><strong>Category:</strong> {profile.category}</p>
        </div>
        </div>
        <div className='row mb-4'>
          <div className='col-6'>
            <p><strong>Date of Birth:</strong> {moment(profile.dob).format('DD/MM/YYYY')}</p>
          </div>
          <div className='col-6'>
            <p><strong>Gender:</strong> {profile.gender}</p>
          </div>          
        </div>
        <div className='row mb-4'>
        <div className='col-6'>
            <p><strong>Father's Name:</strong> {profile.fatherName}</p>
          </div>
          <div className='col-6'>
            <p><strong>Mother's Name:</strong> {profile.motherName}</p>
          </div>
        </div>
        <Link to={`/student/${profile.email}/edit`} className='text-success'><EditIcon/></Link>
      </div>
    </div>
  );
};

export default Profile;
